import { useEffect, useMemo } from 'react';

import { RealTimeService } from '../helpers/RealTimeService';
import {
  ConnectionStatus,
  useRealTimeStatus,
} from '../providers/RealTimeProvider';
import { camelize } from '@/helpers/common';
import { useCommonStore } from '@/store';

export const useSubscription = <T>(
  channel: string | null,
  onMessage: (data: T) => void,
  channelStatus: ConnectionStatus = ConnectionStatus.Private
) => {
  const { status } = useRealTimeStatus();

  const playerSettings = useCommonStore.use.playerSettings();

  const subscriptionChannel = useMemo(() => {
    if (channelStatus === ConnectionStatus.Private) {
      const user = playerSettings?.cent.user;

      return user ? `${channel}#${user}` : null;
    }

    return channel;
  }, [channel, channelStatus, playerSettings?.cent.user]);

  useEffect(() => {
    if (!subscriptionChannel || status === ConnectionStatus.Disconnected) {
      return;
    }

    const handleMessage = (data: T) => {
      const camelizedData = camelize(data as any) as T;
      onMessage(camelizedData);
    };

    const realTimeService = RealTimeService.getInstance();

    realTimeService.subscribe<T>(subscriptionChannel, handleMessage);

    return () => {
      realTimeService.unsubscribe(subscriptionChannel);
    };
  }, [subscriptionChannel, status, onMessage]);
};
